/**
 * Melding voor producten die buiten de EU worden gemaakt en verzonden (VK sinds
 * Brexit buiten de EU-douane-unie, geen IOSS-registratie). Losse UI, dus
 * contentLocked-omschrijvingen blijven onaangeroerd. Bron en tekst staan in
 * `@/lib/shipping-origin`; geen leveranciersnamen.
 *
 * Geen hooks: bruikbaar in server- en clientcomponenten.
 */
import { Info } from 'lucide-react';
import { resolveShippingOrigin, shippingOriginNoticeCopy } from '@/lib/shipping-origin';

export function ShippingOriginNotice({
  productId,
  productSlug,
  sku,
  specifications,
  locale,
  compact = false,
  className = '',
}: {
  productId?: string | null;
  productSlug?: string | null;
  sku?: string | null;
  specifications?: unknown;
  locale: string;
  compact?: boolean;
  className?: string;
}) {
  const origin = resolveShippingOrigin({ productId, productSlug, sku, specifications });
  if (!origin) return null;
  const { title, body } = shippingOriginNoticeCopy(origin, locale);

  if (compact) {
    return (
      <div
        role="note"
        data-shipping-origin={origin}
        className={`flex gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs leading-5 text-amber-950 ${className}`}
      >
        <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        <p className="min-w-0 break-words">{body}</p>
      </div>
    );
  }

  return (
    <div
      role="note"
      data-shipping-origin={origin}
      className={`mb-5 flex gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-amber-950 ${className}`}
    >
      <Info className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
      <div className="min-w-0">
        <p className="text-sm font-bold">{title}</p>
        <p className="mt-1 text-sm leading-6">{body}</p>
      </div>
    </div>
  );
}
